module.exports = __webpack_public_path__ + "img/laptop-hts.89ce977e.png";